import React, { useEffect } from 'react';

const Cookies = () => {
    const baseUrl = 'https://jermingo.com';
    
    useEffect(() => {
        // Update document title
        document.title = 'Cookie Policy | Jermingo';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        metaDesc.setAttribute('content', 
            'Learn about Jermingo\'s Cookie Policy. Understand how we use cookies, including Google AdSense cookies, and how to manage your cookie preferences.'
        );
        
        // Add canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', `${baseUrl}/cookies`);
    }, []);
    
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
            <h1>Cookie Policy</h1>
            <p>
                This Cookie Policy explains how Jermingo ("we", "our", or "us") uses cookies and similar technologies 
                to recognize you when you visit our website. It explains what these technologies are, why we use them, 
                and your rights to control their use.
            </p>

            <h2>What Are Cookies?</h2>
            <p>
                Cookies are small text files that are stored on your device (computer, smartphone, or other device) 
                when you visit a website. They are widely used to make websites work more efficiently and to provide 
                information to the website owners.
            </p>

            <h2>How We Use Cookies</h2>
            <p>
                We use cookies to enhance your browsing experience and to display advertisements through third-party 
                services such as Google AdSense. These cookies may collect information about your browsing behavior 
                to serve personalized ads based on your interests.
            </p>

            <h2>Third-Party Cookies</h2>
            <p>
                Our website uses third-party services, including Google AdSense, which may place cookies on your device 
                to serve personalized advertisements. These cookies allow Google and its partners to display ads based 
                on your visit to this site and other websites on the Internet.
            </p>
            <p>
                For more information about how Google uses cookies in advertising, visit the 
                <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
                    Google Ads Policies
                </a>.
            </p>

            <h2>Your Choices</h2>
            <p>
                You can control or disable cookies through your browser settings. Most browsers allow you to:
            </p>
            <ul>
                <li>View what cookies are stored on your device</li>
                <li>Delete all or specific cookies</li>
                <li>Block cookies from specific websites</li>
                <li>Disable all cookies</li>
            </ul>
            <p>
                Please note that disabling cookies may affect the functionality of this website and other websites you visit.
            </p>

            <h2>Managing Google AdSense Cookies</h2>
            <p>
                You can manage your preferences for personalized ads served by Google by visiting the 
                <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
                    Google Ads Settings
                </a>.
            </p>

            <h2>Changes to This Cookie Policy</h2>
            <p>
                We may update this Cookie Policy from time to time to reflect changes in our practices or for other 
                operational, legal, or regulatory reasons. Please revisit this page periodically to stay informed 
                about how we use cookies.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions about this Cookie Policy, you can contact us at:
            </p>
            <ul>
                <li>Email: <a href="mailto:privacy@jermingo.com">privacy@jermingo.com</a></li>
            </ul>
        </div>
    );
};

export default Cookies;